import React from 'react';
import FutbolEnhanced from '../components/FutbolEnhanced';

const FutbolPage = () => {
  return (
    <div className="page-container">
      <FutbolEnhanced />
    </div>
  );
};

export default FutbolPage;